import { cva } from "class-variance-authority";

export const serviceCardCardWrapper = cva(
  "relative p-[2px] rounded-2xl h-full",
  {
    variants: {
      variant: {
        "emerald-mint": "bg-gradient-to-b from-emerald-400 to-transparent",
        "sky-bliss": "bg-gradient-to-b from-sky-bliss to-transparent",
        "teal-ocean": "bg-gradient-to-b from-teal-ocean to-transparent",
        "sunset-gold": "bg-gradient-to-b from-sunset-gold to-transparent",
        "yellow-500": "bg-gradient-to-b from-yellow-500 to-transparent",
        "rose-500": "bg-gradient-to-b from-rose-500 to-transparent",
      },
    },
  },
);

export const serviceCardCardTitle = cva(
  "text-sm lg:text-base font-bold",
  {
    variants: {
      variant: {
        "emerald-mint": "text-emerald-mint",
        "sky-bliss": "text-sky-bliss",
        "teal-ocean": "text-teal-ocean",
        "sunset-gold": "text-sunset-gold",
        "yellow-500": "text-yellow-500",
        "rose-500": "text-rose-500",
      },
    },
  },
);

export const serviceCardIconWrapper = cva(
  "shadow-main flex h-9 w-9 shrink-0 overflow-hidden border border-transparent items-center justify-center p-2 rounded-full bg-white transition",
  {
    variants: {
      variant: {
        "emerald-mint":
          "group-hover:shadow-emerald-mint! group-hover:border-emerald-mint!",
        "sky-bliss":
          "group-hover:shadow-sky-bliss! group-hover:border-sky-bliss!",
        "teal-ocean":
          "group-hover:shadow-teal-ocean! group-hover:border-teal-ocean!",
        "sunset-gold":
          "group-hover:shadow-sunset-gold! group-hover:border-sunset-gold!",
        "yellow-500":
          "group-hover:shadow-yellow-500! group-hover:border-yellow-500!",
        "rose-500":
          "group-hover:shadow-rose-500! group-hover:border-rose-500!",
      },
    },
  },
);
export const serviceCardTitle = cva(
  "flex-1 text-xs leading-5 lg:text-sm text-gray-700 transition-colors",
  {
    variants: {
      variant: {
        "emerald-mint": "group-hover:text-emerald-mint!",
        "sky-bliss": "group-hover:text-sky-bliss!",
        "teal-ocean": "group-hover:text-teal-ocean!",
        "sunset-gold": "group-hover:text-sunset-gold!",
        "yellow-500": "group-hover:text-yellow-500!",
        "rose-500": "group-hover:text-rose-500!",
      },
    },
  },
);

export const serviceCardIconClass = cva("size-5", {
  variants: {
    variant: {
      "emerald-mint": "text-emerald-mint!",
      "sky-bliss": "text-sky-bliss!",
      "teal-ocean": "text-teal-ocean!",
      "sunset-gold": "text-sunset-gold!",
      "yellow-500": "text-yellow-500!",
      "rose-500": "text-rose-500!",
    },
  },
});

export const dropdownVariants = cva(
  "relative rounded-md sm:rounded-xl border xl:px-4 px-1 sm:px-2 xl:py-2 py-1 size-full cursor-pointer transition-colors",
  {
    variants: {
      variant: {
        default: "bg-white text-gray-800 border-primary-main",
        primary: "bg-primary-main text-white border-primary-main",
        outline: "bg-transparent text-primary-main!",
        shadow:
          "bg-transparent text-primary-main shadow-main border border-gray-300",
        flat: "bg-transparent border-none",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);
